import 'bootstrap'
import $ from 'jquery'

let windowLoaded = false;
$(window).on('load', () => {
    windowLoaded = true;
});

$(document).ready(() => {
    const $htmlBody = $('html, body');
    const $navbarCollapse = $('.navbar-collapse');

    // CONTACT FORM SUBMISSION
    $('.form-script').submit(e => {
        e.preventDefault();

        const $form = $(e.currentTarget);
        const $submitBtn = $form.find('*[type=submit]');

        $submitBtn
            .prop('disabled', true)
            .attr('disabled', 'disabled')
            .addClass('btn-disabled');

        $form.find('.is-invalid').removeClass('is-invalid');
        $form.find('.invalid-feedback').remove();
        $form.find('.form-error-box').html('');

        $.ajax({
            url: $form.attr('action'),
            type: $form.attr('method'),
            data: new FormData(e.currentTarget),
            dataType: 'json',
            cache: false,
            contentType: false,
            processData: false,
            success: result => {
                if (typeof result.status !== 'undefined') {
                    if (result.status === 200) {
                        $form.trigger("reset");
                        alert('Ihre Anfrage wurde erfolgreich abgesendet!');
                    } else if (result.status === 400) {
                        for (let key in result.data) {
                            $form.find('[name=' + key + ']')
                                .addClass('is-invalid')
                                .parent()
                                .append('<div class="invalid-feedback">' + result.data[key] + '</div>');
                        }
                        $form.find('.form-error-box')
                            .html('<div class="alert alert-danger" role="alert">Bitte überprüfen Sie das Formular.</div>');

                    }
                }

                $submitBtn
                    .prop('disabled', false)
                    .removeAttr('disabled')
                    .removeClass('btn-disabled');
            }
        });
    });

    // SMOOTH SCROLL TO ANCHOR
    let isAnimatingScroll = false;
    const anchorScrollOffset = -8 * 16;
    $('a[href^="#"]').on('click', function (event) {
        event.preventDefault();

        const href = $(this).attr('href');
        const $anchor = href === '#' ? $(document.body) : $(href);

        if ($anchor.length > 0) {
            isAnimatingScroll = true;
            $htmlBody.animate({
                scrollTop: $anchor.offset().top + anchorScrollOffset
            }, 500, 'swing', () => {
                isAnimatingScroll = false;
            });

            $navbarCollapse.removeClass('show');

            $('.nav-item').removeClass('active');
            $(this).parent('.nav-item').addClass('active');

        }
    });

    const sectionBounds = new Map();
    $('section').each(function () {
        sectionBounds.set(this, {
            top: this.offsetTop,
            bottom: this.offsetTop + this.offsetHeight
        });
    });


    $(window).on('scroll', function () {
        checkActiveNav();
    });

    if (windowLoaded) {
        checkActiveNav();
        showPage();
    } else {
        $(window).on('load', () => {
            checkActiveNav();
            showPage();
        });
    }

    function showPage() {
        $(document.body).removeClass('opacity-0');
    }

    function checkActiveNav() {
        if (isAnimatingScroll) return;

        const y = $htmlBody.scrollTop() - anchorScrollOffset;

        sectionBounds.forEach((bounds, section) => {
            if (!(y >= bounds.top && y < bounds.bottom)) return;
            $('.nav-item').removeClass('active');

            const id = section.dataset.activeNav;
            if (!id || id === '') {
                // activate default nav
                const $navItem = $('.nav-item[data-nav="' + window.pageData.page + '"]')
                $navItem.addClass('active');
            } else {

                const $navItem = $('.nav-item[data-nav="' + id + '"]');
                $navItem.addClass('active');
            }
        });
    }
});


// WEBPACK FOOTER //
// ./assets/JavaScript/Default/Main.js